import { ActiveOrderDsService, ProductionOrderDsService } from '@app/core/data-services';
import { Injectable } from '@angular/core';
import { ConsumedMaterialQuery, ConsumedMaterialService } from '@app/modules/mounting/state';
import { MountedMaterialViewModel } from 'chronos-core-client';
import * as R from 'ramda';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { SortDirection } from 'chronos-shared';

@Injectable({
  providedIn: 'root'
})
export class ConsumedMaterialDsService {
  constructor(
    private consumedMaterialQuery: ConsumedMaterialQuery,
    private consumedMaterialService: ConsumedMaterialService,
    private productionOrderDsService: ProductionOrderDsService,
    private activeOrderDsService: ActiveOrderDsService
  ) {}

  public getConsumedMaterial(): Observable<MountedMaterialViewModel[]> {
    return this.renewConsumedMaterial().pipe(switchMap(() => this.consumedMaterialQuery.consumedMaterial$));
  }

  public renewConsumedMaterial(): Observable<MountedMaterialViewModel[]> {
    const activeOrder = this.activeOrderDsService.getActiveOrder();
    return this.productionOrderDsService.getConsumptionForProductionOrder(activeOrder.productionOrderId, activeOrder.runId).pipe(
      map(R.prop('consumedMountedMaterials')),
      tap((consumedMaterial: MountedMaterialViewModel[]) => {
        this.consumedMaterialService.set(consumedMaterial);
      })
    );
  }

  public getPalletSequence(): Observable<SortDirection> {
    return this.consumedMaterialQuery.palletSequence$;
  }

  public updateFilters(showOnlyDummy: boolean): void {
    this.consumedMaterialService.updateFilters({ showOnlyDummy });
  }

  public updateSorting(palletSequence: SortDirection): void {
    this.consumedMaterialService.updateSorting({ palletSequence });
  }

  public resetConsumedMaterial(): void {
    this.consumedMaterialService.reset();
  }
}
